/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Module } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IBusinessPartnersViewProps } from './eve-business-partners';

/**
 * View layout of business partner module.
 * @param props - React props of the component.
 * @returns Functional component.
 */
const businessPartnersView: React.FC<IBusinessPartnersViewProps> = props => {
    if (props.selectedBusinessPartnerUser) {
        return (
            <Module {...props.businessPartnersProps}>
                {props.businessPartnersHeading}
                {props.catalogLoadingIndicator}
                {props.catalogLoadingErrorMessage}
            </Module>
        );
    }

    if (props.cookieConsentNotGivenErrorMessage) {
        return (
            <Module {...props.businessPartnersProps}>
                {props.businessPartnersHeading}
                {props.cookieConsentNotGivenErrorMessage}
            </Module>
        );
    }

    return (
        <Module {...props.businessPartnersProps}>
            {props.backToBusinessPartnersLink}
            {props.searchBar}
            {props.businessPartnersHeading}
            {props.businessPartnersTable}
            {props.businessPartnerUsersTable}
        </Module>
    );
};

export default businessPartnersView;
